import { ThemeButtonImage } from '@shared/ui/buttons';
import { useStartVerificationDialog } from '@utils/dialogs-hooks';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import EmailBtn from '@widgets/buttons/EmailBtn';
import TelegramBtn from '@widgets/buttons/TelegramBtn';

export default function StartVerificationBtn() {
  const { openStartVerificationDialog } = useStartVerificationDialog();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);

  if (user.is_onboarding) {
    return (
      <div className="btns-toolbar">
        <TelegramBtn />
        <EmailBtn />
      </div>
    );
  }

  return (
    <ThemeButtonImage
      name="start-verification"
      animation="rotate-y"
      onClick={openStartVerificationDialog}
    >
      {t('start_verification')}
    </ThemeButtonImage>
  );
}
